import login from './en-US-login.json'
import plan from './en-US-plan.json'
export default {
  sideBar: {
    dashboard: 'DASHBOARD',
    product: 'PRODUCT MANAGEMENT',
    user: 'USER MANAGEMENT',
    order: 'ORDER MANAGEMENT',
    tag: 'TAG MANAGEMENT',
    plan: 'PLAN MANAGEMENT',
    store: 'STORE MANAGEMENT',
    subsidiary: 'SUBSIDIARY MANAGEMENT',
    channel: 'CHANNEL MANAGEMENT',
    admin: 'ADMIN MANAGEMENT',
    logs: 'LOGS',
    vechainorder: 'TAG ORDER MANAGEMENT'
  },
  headBar: {
    logout: 'Logout',
    change_pwd: 'Change Password',
    lang: '语言',
    en: 'English',
    cn: '中文'
  },
  product: {
    tt_sku: 'SKU',
    tt_name: 'Name',
    tt_size: 'Size',
    tt_color: 'Color',
    tt_category: 'Category',
    tt_more: 'More',
    list_title: 'Product Management',
    form_name: 'Name',
    form_sku: 'SKU',
    form_ean: 'Code EAN',
    form_category: 'Category',
    form_color: 'Color',
    form_size: 'Size',
    form_material: 'Material',
    form_dimension: 'Dimension',
    form_desp: 'Description',
    msg_up_suces: 'Upload Success',
    msg_up_failed: 'Upload Failed',
    code_ean: 'EAN Code'
  },
  order: {
    list_title: 'Order Management',
    tt_id: 'Order#',
    tt_sole_count: 'Sold Quantity',
    tt_return_count: 'Return Quantity',
    tt_ship_date: 'Shipping Date',
    tt_more: 'More',
    search: 'SKU',
    detail_id: 'Tag ID',
    detail_sku: 'SKU',
    detail_num: 'Serial Number',
    detail_by: 'Prepare by',
    detail_return_by: 'Return QC by',
    detail_comment: 'Comment',
    list_search: 'Order Number',
    date_range: 'Date Range',
    comment_time: 'Time',
    channel_code: 'Channel Code',
    subsidiary_code: 'Subsidiary Code',
    due_date: 'Due Date',
    cancel_order: 'Please confirm to cancel the order!',
    alert: 'Alert',
    sure: 'Confirm',
    cancel_success: 'Cancel Order Success!',
  },
  common: {
    search: 'Search',
    opera_view: 'Details',
    opera_edit: 'Edit',
    opera_add: 'ADD',
    opera_save: 'Save',
    opera_create: 'CREATE',
    opera_export: 'EXPORT',
    opera_confirm: 'Confirm',
    opera_cancel_order: 'Cancel Order',
    opera_download_pictures: "Download Picture",
    opera_back: 'BACK',
    opera_delete: 'Delete',
    reset_pwd: 'Reset Password',
    upload: 'UPLOAD',
    error_required: 'Required!',
    error_positive_num: 'Number must be greater than 0!',
    msg_up_suces: 'Upload Success',
    msg_up_failed: 'Upload Failed',
    no_data: 'No Data',
    select: 'Select',
    selected: 'Selected',
    confirm: 'Confirm',
    subsidiary: 'Subsidiary',
    channel: 'Channel',
    status: 'Status',
    batchNumber: 'Batch Number',
    dueTime: 'Due Date',
    tagId: 'Tag ID',
    sku: 'SKU',
    action: 'Action',
    comment: 'Comment',
    time: 'Time',
    operator: 'operator'
  },
  user: {
    list_title: 'User Management',
    tt_name: 'Username',
    tt_type: 'Type',
    tt_location: 'Location',
    tt_code: 'Location Code',
    tt_more: 'More',
    form_name: 'Username',
    form_type: 'Type',
    form_location: 'Location',
    reset_pwd: 'Please confirm to reset the password? (if you have any question please contact technical support team)',
    delete_user: 'Please confirm to delete the user?',
    alert: 'Alert',
    sure: 'Confirm',
    reset_success: 'Reset Password Success!',
    delete_success: 'Delete User Success!',
    form_identifycode: 'Code',
    add_success: 'Add User Success!',
    update_success: 'Update User Success!',
    list_search: 'Username',
    source: 'Source',
    destination: 'Destination',
    special_user: 'Special User',
    edit_pictures: 'Edit Pictures'
  },
  changePwd: {
    title: 'Change Password',
    old_pass: 'Current Password',
    new_pass: 'New Password',
    check_pass: 'Confirm Password',
    change: 'CONFIRM',
    new_pass_error: 'Type your new password again',
    requirement:'Password Not Satisfiable',
    success: 'Change Password Success!',
    verify_code: 'Verify code',
    send_sms: 'Verify code has been sent to your mobile phone',
    get_code: 'Get verfiy code',
    countdown: 'send again after {auth_time} seconds'
  },
  store: {
    list_title: 'Store Management',
    list_id: 'Store ID',
    list_type: 'Type',
    list_location: 'Location',
    list_location_code: 'Location Code',
    list_channel_code: 'Channel Code',
    list_subsidiary_code: 'Subsidiary Code',
    list_subsidiary: 'Subsidiary',
    list_channel: 'Channel',
    prefix: 'Prefix',
    update_success: 'Update Store Success!',
    update_success: 'Update Store Success!'

  },
  subsidiary: {
    subsidiary_title: 'Subsidiary Management',
    subsidiary_name: 'Subsidiary Name',
    subsidiary_code: 'Subsidiary Code',
    vechain_url: 'Chip URL',
    description: 'Description',
    add_success: 'Add Subsidiary Success!'
  },
  channel: {
    channel_title: 'Channel Management',
    channel_name: 'Channel Name',
    channel_code: 'Channel Code',
    description: 'Description',
    add_success: 'Add Channel Success!'

  },
  error: {
    error1001: 'Sorry, please login',
    error1002: 'Invalid login, please try to login again',
    error1003: 'Invalid login, please try to login again',
    error1004: 'Sorry,wrong password, please try again',
    error1005: 'Invalid Code_EAN, please try again',
    error1006: 'Invalid Tag, please contact technical support',
    error1007: 'Invalid SKU, please contact technical support',
    error1009: 'Import failed, please check the excel format',
    error1010: 'Order does not exist',
    error1011: 'User already existed',
    error1012: 'Invalid username',
    error1018: 'Invalid store ID',
    error9000: 'Sorry,wrong username/password, please try again',
    error9001: 'Sorry,you use the wrong login method, please switch login method',
    error_default: 'Unknown error, please contact technical support'
  },
  dashboard: {
    title: 'Dashboard',
    today: 'TODAY',
    history: 'History',
    orders_chart_title: 'Orders',
    products_chart_title: 'Product Ratio',
    category_chart_title: 'Category Ratio',
    return_table_title: 'Return Details',
    days_7: '7 Days',
    days_14: '14 Days',
    days_30: '30 Days',
    today_orders: 'Orders',
    today_return: 'Return',
    today_products: 'Products',
    today_category: 'Category',
    table_location_code: 'Location Code',
    table_count: 'Count',
    table_create_time: 'Last Return'
  },
  logs:{
    action:'Action',
    date:'Date',
    title:'LOGS',
    ip_address:'IP Address',
    type:'Type',
    detail:'Detail'
  },
  admin: {
    title: 'Admin Management',
    account: 'Account',
    realname: 'Name',
    type: 'Type',
    adminlevel: 'Type',
    mobile: 'Mobile',
    Managed: 'Managed',
    disabled: 'Disabled',
    description: 'Description',
    enable_cancel: 'Cancel Delivery',
    enable_order: 'Create Tag Order',
    email: 'Email',
    add_success: 'Add Admin Success!',
    update_success: 'Update Admin Success!',
  },
  vechainorder: {
    title: 'Tag Order Management',
    opera_order: 'ORDER',
    request_num: 'Request#',
    order_num: 'Order#',
    product_id: 'Tag ID',
    product_name: 'Name',
    quantity: 'Quantity',
    package_count: 'Package Count',
    operator_name: 'User',
    receiver: 'Receiver',
    order_time: 'Order Time',
    status: 'Status',
    more: 'More',
    detail: 'Details',
    confirm: 'Confirm',
    import: 'Import',
    confirm_request: 'Do you want to confirm receiving the package?',
    alert: 'Notice',
    sure: 'Confirm',
    confirm_success: 'Confirm success! Please refresh the page later to check Vechain ID import status!',
    import_request: 'Do you want to import Vechain Tags?',
    import_success: 'Please refresh the page later to check Vechain ID import status!',
    order_success: 'Order success!',
    subsidiary: 'Subsidary',
    channel: 'Channel',
    vechain_url: 'Chip URL'
  },
  vechainorder_detail: {
    tag_info: 'Tag Information',
    product_id: 'Tag ID',
    product_name: 'Name',
    quantity: 'Quantity',
    total_price: 'Total Amount',
    receiver_info: 'Receiver Information',
    receiver: 'Receiver',
    address: 'Addr',
    email: 'Email',
    telephone: 'Tel',
    logistic_info: 'Logistics Information',
    logistic_number: 'Logistics#',
    logistic_time: 'Delivery Time',
    logistic_comment: 'Comment',
    chipUrl: 'Chip URL'
  },
  plan,
  login
}



// WEBPACK FOOTER //
// ./src/i18n/en-US.js